import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import he from './he.json';
import { readSavedLang, startLang } from '../utils/langPath';

function safeLocalStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

// The address decides the language (docs/seo-plan.md), never the browser's
// language: Google's robot has an English browser and must see each copy as
// its address says. A visitor's own earlier choice moves them to their copy
// before anything is shown.
const start = startLang(window.location.pathname, readSavedLang(safeLocalStorage()));
if (start.moveTo) {
  window.history.replaceState(window.history.state, '', start.moveTo + window.location.search + window.location.hash);
}
/** True when the address was changed to the visitor's language (the pre-rendered page is then the wrong language). */
export const movedToSavedLang = start.moveTo !== null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he }
    },
    lng: start.lang,
    fallbackLng: 'he',
    supportedLngs: ['he', 'en'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false }
  });

export default i18n;
